import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { alpha } from "@mui/material/styles";
import usePlanner from "features/planner/state/usePlanner";

function ClearMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const { clearDay, clearAll } = usePlanner();

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClearDay = (dayNumber) => {
    clearDay(`day${dayNumber}`);
    handleClose();
  };

  const handleClearAll = () => {
    clearAll();
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleOpen}
        startIcon={<CleaningServicesIcon sx={{ fontSize: 16, color: "error.main" }} />}
        sx={{
          borderRadius: "12px",
          textTransform: "none",
          fontWeight: 600,
          fontSize: "0.85rem",
          paddingY: "8px",
          borderWidth: "1.5px",
          borderColor: "error.main",
          backgroundColor: (theme) => alpha(theme.palette.error.main, 0.04),
          color: "error.main",

          width: { xs: "100%", md: "90%", lg: "100%" },
          maxWidth: "260px",
          margin: "0 auto",

          "&:hover": {
            backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08),
            borderColor: "error.main",
          },
        }}
      >
        Limpiar
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            mt: 0.5,
            minWidth: 160,
          },
        }}
      >
        {[1, 2, 3, 4, 5, 6, 7].map((n) => (
          <MenuItem
            key={n}
            onClick={() => handleClearDay(n)}
            sx={{
              fontSize: "0.85rem",
              paddingY: "6px",
            }}
          >
            Día {n}
          </MenuItem>
        ))}

        <MenuItem
          onClick={handleClearAll}
          sx={{
            mt: 0.5,
            color: "error.main",
            fontWeight: 600,
            borderTop: "1px solid",
            borderColor: "grey.300",
            paddingY: "8px",
            "&:hover": {
              backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08),
            },
          }}
        >
          Limpiar todo
        </MenuItem>
      </Menu>
    </>
  );
}

export default ClearMenu;
